import { render, staticRenderFns } from "./Cxv.vue?vue&type=template&id=a8d43580&scoped=true"
import script from "./Cxv.vue?vue&type=script&lang=js"
export * from "./Cxv.vue?vue&type=script&lang=js"
import style0 from "./Cxv.vue?vue&type=style&index=0&id=a8d43580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d43580",
  null
  
)

export default component.exports